const ROW_OVERFLOW_TOLERANCE_PX = 1;

export const canScrollHorizontally = (
  element: Pick<HTMLElement, 'scrollWidth' | 'clientWidth'> | null,
): boolean =>
  Boolean(element && element.scrollWidth > element.clientWidth + ROW_OVERFLOW_TOLERANCE_PX);
